export default __webpack_public_path__ + "static/media/06.7365b7fa.jpg";